<div class="login-container">
  <!-- Background Animation -->
  <div class="background-animation">
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>
  </div>

  <!-- Main Login Card -->
  <div class="login-card" [class.shake]="showShakeAnimation">
    <!-- Header -->
    <div class="login-header">
      <div class="logo-container">
        <div class="logo">
          <img src="/assets/images/logo.png" alt="Familitive Logo" 
               onerror="this.style.display='none'; this.nextElementSibling?.style.setProperty('display', 'inline-flex');" />
          <!-- Fallback SVG if image fails to load -->
          <svg class="logo-fallback" style="display: none;" width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
            <path d="M19 15L19.5 17.5L22 18L19.5 18.5L19 21L18.5 18.5L16 18L18.5 17.5L19 15Z" fill="currentColor"/>
            <path d="M5 15L5.5 17.5L8 18L5.5 18.5L5 21L4.5 18.5L2 18L4.5 17.5L5 15Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      <h1 class="login-title">Welcome Back</h1>
      <p class="login-subtitle">Sign in to your Familitive account</p>
    </div>

    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <!-- Username Field -->
      <div class="form-group">
        <div class="input-container">
          <div class="input-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <input 
            type="text" 
            class="form-input"
            formControlName="username"
            [class.error]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
            placeholder="Username or Email"
            autocomplete="username">
          <div class="input-focus-line"></div>
        </div>
        <div class="error-message" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
            <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
          </svg>
          Username is required
        </div>
      </div>

      <!-- Password Field -->
      <div class="form-group">
        <div class="input-container">
          <div class="input-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
              <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <input 
            [type]="showPassword ? 'text' : 'password'" 
            class="form-input"
            formControlName="password"
            [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
            placeholder="Password"
            autocomplete="current-password">
          <button 
            type="button" 
            class="password-toggle"
            (click)="togglePassword()"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
            <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
            </svg>
            <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20C5 20 1 12 1 12A18.45 18.45 0 0 1 5.06 5.06L17.94 17.94Z" stroke="currentColor" stroke-width="2"/>
              <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4C19 4 23 12 23 12A18.5 18.5 0 0 1 19.34 16.34L9.9 4.24Z" stroke="currentColor" stroke-width="2"/>
              <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2"/>
            </svg>
          </button>
          <div class="input-focus-line"></div>
        </div>
        <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
            <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
          </svg>
          Password is required
        </div>
      </div>

      <!-- Remember Me & Forgot Password -->
      <div class="form-options">
        <label class="checkbox-container">
          <input type="checkbox" formControlName="rememberMe">
          <span class="checkmark"></span>
          Remember me
        </label>
        <a routerLink="/forgot-password" class="forgot-password">Forgot Password?</a>
      </div>

      <!-- Submit Button -->
      <button 
        type="submit" 
        class="login-button"
        [disabled]="loginForm.invalid || isLoading"
        [class.loading]="isLoading">
        <span class="button-content">
          <svg *ngIf="isLoading" class="loading-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-dasharray="31.416" stroke-dashoffset="31.416">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
            </circle>
          </svg>
          <span class="button-text">{{ isLoading ? 'Signing In...' : 'Sign In' }}</span>
        </span>
      </button>

      <!-- Divider -->
      <!-- <div class="divider">
        <span>or</span>
      </div> -->

      <!-- Referral Codes Section (for Google Sign-Up) -->
      <!-- <div class="referral-codes-section" *ngIf="showReferralCodes || parentReferralCode || spouseReferralCode">
        <div class="form-group">
          <label class="form-label">Parent/Child Referral Code (Optional)</label>
          <div class="input-container">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2"/>
                <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2"/>
                <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <input 
              type="text" 
              class="form-input"
              formControlName="parentReferralCode"
              placeholder="Enter parent/child referral code">
            <div class="input-focus-line"></div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Spouse Referral Code (Optional)</label>
          <div class="input-container">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
                <circle cx="16" cy="16" r="4" stroke="currentColor" stroke-width="2"/>
                <path d="M11 11L13 13" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <input 
              type="text" 
              class="form-input"
              formControlName="spouseReferralCode"
              placeholder="Enter spouse referral code">
            <div class="input-focus-line"></div>
          </div>
        </div>
      </div> -->

      <!-- Toggle Referral Codes Button -->
      <!-- <div class="referral-toggle-section">
        <button 
          type="button" 
          class="link-button"
          (click)="toggleReferralCodes()">
          <span *ngIf="!showReferralCodes">Have referral codes? Add them</span>
          <span *ngIf="showReferralCodes">Hide referral codes</span>
        </button>
      </div> -->

      <!-- Google Sign-In Button -->
      <!-- <div id="google-signin-button" class="google-signin-container"> -->
        <!-- Fallback message while loading -->
        <!-- <div class="google-loading-message" style="text-align: center; color: #64748b; font-size: 14px; padding: 12px;">
          Loading Google Sign-In...
        </div> -->
      <!-- </div> -->

      <!-- Error Message -->
      <div class="error-alert" *ngIf="errorMessage" [class.show]="errorMessage">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
          <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
        </svg>
        {{ errorMessage }}
      </div>
    </form>

    <!-- Footer -->
    <div class="login-footer">
      <p class="signup-prompt">Don't have an account?</p>
      <button 
        type="button"
        class="signup-button"
        routerLink="/signup">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 9V12M18 12V15M18 12H15M18 12H21M10 12C10 14.2091 8.20914 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C8.20914 8 10 9.79086 10 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Create Account</span>
      </button>
    </div>
  </div>

  <!-- Privacy Agreement Popup -->
  <app-privacy-agreement-popup
    [isVisible]="showPrivacyAgreement"
    (agreementAccepted)="onPrivacyAgreementAccepted()"
    (agreementRejected)="onPrivacyAgreementRejected()">
  </app-privacy-agreement-popup>
</div>
